import { lazy } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
//import IndexLayout from './features/shared/components/layout/IndexLayout';
import MainLayout from '../view/MainLayout';
import LoginPage from '../../auth/signin/page/LoginPage';
//import ResetPasswordPage from './pages/reset-password';
import CheckAuthComp from '@/auth/signin/view/CheckAuthComp';
import RequireAuthComp from '@/auth/signin/view/RequireAuthComp';
import UnauthorizedPage from '../../auth/signin/page/UnauthorizedPage';
import { PATH } from '@/main/controller/MainController';
import MainSetting from '@/main/model/MainSetting';
import PageFrame from '../../common/view/PageFrame';
import { AuthRedirectPage } from '@/auth/redirect/page/AuthRedirectPage';
import CustomerDetailPage from '@/dashboard/customer/detail/page/CustomerDetailPage';

const CampaignOverviewPage = lazy(() => import('@/campaign/main/page/CampaignListPage'));
const CampaignItemPage = lazy(() => import('@/campaign/item/main/page/CampaignItemPage'));
const StrategyOverviewPage = lazy(() => import('@/strategy_notused/main/page/StrategyOverviewPage'));
const StrategyMutatePage = lazy(() => import('@/strategy_notused/item/page/StrategyMutatePage'));
const AudienceOverviewPage = lazy(() => import('@/audience/main/page/AudienceOverviewPage'));
const TemplateSettingPage = lazy(() => import('@/message-template/page/TemplateSettingPage'));
const SettingPage = lazy(() => import('@/setting/main/page/SettingPage'));

const ContentsOverviewPage = lazy(() => import('@/content/main/page/ContentListPage'));
const ContentItemPage = lazy(() => import('@/content/item/page/ContentItemPage'));
const ImagePage = lazy(() => import('@/image/main/page/ImagePage'));
const ProductsOverviewPage = lazy(() => import('@/product/list/page/ProductListPage'));
const ProductsMutatePage = lazy(() => import('@/product/item/page/ProductItemPage'));
const OnboardingPage = lazy(() => import('@/auth/onboarding/page/OnboardingPage'));
const DashboardCampaignAnalysisPage = lazy(() => import('@/dashboard/campaign/page/CampaignAnalysisPage'));
const DashboardSendingSetAnalysisPage = lazy(
  () => import('@/dashboard/sending-set/page/SendingSetAnalysisPage'),
);
// const DashboardTrendAnalysisPage = lazy(() => import('@/dashboard/page/trend-analysis'));
const DashboardAudienceAnalysisPage = lazy(() => import('@/dashboard/audience/page/AudienceAnalysisDashboardPage'));
const OfferSettingOverviewPage = lazy(() => import('@/benefit_notused/main/page/OfferSettingListPage'));
const OfferSettingDetailPage = lazy(() => import('@/benefit_notused/item/page/OfferDetailPage'));
const BillingOverviewPage = lazy(() => import('@/billing/page/BillingOverviewPage'));

const NoMatchPage = lazy(() => import('@/main/page/NoMatchPage'));
const PaymentResultPage = lazy(() => import('@/billing/page/PaymentResultPage'));
const Cafe24OrderResultPage = lazy(() => import('@/billing/page/Cafe24OrderResultPage'));
const LandingPage = lazy(() => import('@/guide/contactus/page/ContactUsPage'));
const TermsPage = lazy(() => import('@/guide/terms/page/TermsPage'));
const Cafe24AppPage = lazy(() => import('@/main/page/Cafe24AppPage'));
const JoinFromPlatformPage = lazy(() => import('@/auth/join_from_platform/page/JoinFromPlatformPage'));
const JoinPreparedPage = lazy(() => import('@/auth/join_from_platform/page/JoinPreparedPage'));
const UsersPage = lazy(() => import('@/user/page/UsersPage'));
const CustomerListPage = lazy(() => import('@/dashboard/customer/list/page/CustomerListPage'));
const CampaignAgentPage = lazy(() => import('@/dashboard/campaign-agent/page/CampaignAgentPage'));

function App() {
  return (
    <Routes>
      {/* public routes */}
      <Route Component={CheckAuthComp}>
        <Route
          index
          path={PATH.ROOT}
          element={
            <PageFrame>
              <LandingPage />
            </PageFrame>
          }
        />
        <Route path={PATH.TERM_ONBOARDING} element={<TermsPage which="onboarding" />} />
        <Route path={PATH.TERM_PAYMENT} element={<TermsPage which="payment" />} />
        <Route path={PATH.TERM_PRIVACY} element={<TermsPage which="privacy" />} />
        <Route
          path={PATH.CAFE24_APP}
          element={
            <PageFrame>
              <Cafe24AppPage />
            </PageFrame>
          }
        />
        <Route
          path={PATH.JOIN_FROM_PLATFORM}
          element={
            <PageFrame>
              <JoinFromPlatformPage />
            </PageFrame>
          }
        />
        <Route
          path={PATH.JOIN_PREPARED}
          element={
            <PageFrame>
              <JoinPreparedPage />
            </PageFrame>
          }
        />
      </Route>

      <Route
        path={PATH.LOGIN}
        element={
          <div className="app">
            <LoginPage />
          </div>
        }
      />
      {/* <Route path={PATH.RESET_PASSWORD} Component={ResetPasswordPage} /> */}

      {/* protect routes */}
      <Route
        path="main/*"
        element={
          <RequireAuthComp>
            <MainLayout />
          </RequireAuthComp>
        }>
        <Route
          path={`auth/redirect`}
          element={
            <PageFrame>
              <AuthRedirectPage />
            </PageFrame>
          }
        />
        <Route
          path="onboarding"
          element={
            <PageFrame>
              <OnboardingPage />
            </PageFrame>
          }
        />

        <Route
          path="campaign"
          element={
            <PageFrame>
              <CampaignOverviewPage />
            </PageFrame>
          }
        />

        <Route
          path="campaign/create"
          element={
            <PageFrame>
              <CampaignItemPage />
            </PageFrame>
          }
        />

        <Route
          path="campaign/:id"
          element={
            <PageFrame>
              <CampaignItemPage />
            </PageFrame>
          }
        />

        <Route
          path="strategy-manager"
          element={
            <PageFrame>
              <StrategyOverviewPage />
            </PageFrame>
          }
        />
        <Route
          path="strategy-manager/create"
          element={
            <PageFrame>
              <StrategyMutatePage />
            </PageFrame>
          }
        />
        <Route
          path="strategy-manager/:id"
          element={
            <PageFrame>
              <StrategyMutatePage />
            </PageFrame>
          }
        />

        <Route
          path="audience"
          element={
            <PageFrame>
              <AudienceOverviewPage />
            </PageFrame>
          }
        />

        <Route
          path="contents-manager/contents"
          element={
            <PageFrame>
              <ContentsOverviewPage />
            </PageFrame>
          }
        />
        <Route
          path="contents-manager/contents/create"
          element={
            <PageFrame>
              <ContentItemPage />
            </PageFrame>
          }
        />
        <Route
          path="contents-manager/contents/:id"
          element={
            <PageFrame>
              <ContentItemPage />
            </PageFrame>
          }
        />
        <Route
          path="contents-manager/libraries"
          element={
            <PageFrame>
              <ImagePage />
            </PageFrame>
          }
        />
        <Route
          path="contents-manager/products"
          element={
            <PageFrame>
              <ProductsOverviewPage />
            </PageFrame>
          }
        />
        <Route
          path="contents-manager/products/:id"
          element={
            <PageFrame>
              <ProductsMutatePage />
            </PageFrame>
          }
        />
        <Route path="contents-manager" element={<Navigate to={PATH.CONTENTS_MANAGER_CONTENTS_INDEX} />} />
        <Route
          path="message-templates"
          element={
            <PageFrame>
              <TemplateSettingPage />
            </PageFrame>
          }
        />
        <Route
          path="settings/offers"
          element={
            <PageFrame>
              <OfferSettingOverviewPage />
            </PageFrame>
          }
        />
        <Route
          path="settings/offers/:id"
          element={
            <PageFrame>
              <OfferSettingDetailPage />
            </PageFrame>
          }
        />
        <Route
          path="settings/:tabKey?"
          element={
            <PageFrame>
              <SettingPage />
            </PageFrame>
          }
        />
        <Route
          path="users"
          element={
            <PageFrame>
              <UsersPage />
            </PageFrame>
          }
        />

        <Route path="dashboard" element={<Navigate to={PATH.DASHBOARD_CAMPAIGN_ANALYSIS} />} />
        <Route
          path="dashboard/campaign-analysis"
          element={
            <PageFrame>
              <DashboardCampaignAnalysisPage />
            </PageFrame>
          }
        />
        <Route
          path="dashboard/sending-set-analysis"
          element={
            <PageFrame>
              <DashboardSendingSetAnalysisPage />
            </PageFrame>
          }
        />
        {/* <Route
            path="dashboard/trend-analysis"
            element={
              <PageFrame>
                <DashboardTrendAnalysisPage />
              </PageFrame>
            }
          /> */}
        <Route
          path="dashboard/audience-analysis"
          element={
            <PageFrame>
              <DashboardAudienceAnalysisPage />
            </PageFrame>
          }
        />
        <Route
          path="dashboard/customers"
          element={
            <PageFrame>
              <CustomerListPage />
            </PageFrame>
          }
        />
        <Route
          path="dashboard/customers/:id"
          element={
            <PageFrame>
              <CustomerDetailPage />
            </PageFrame>
          }
        />
        {MainSetting.showCustomerAnalysisAgent && (
          <Route
            path="dashboard/campaign-agent"
            element={<Navigate to={PATH.DASHBOARD_AGENT} replace />}
          />
        )}
        {MainSetting.showCustomerAnalysisAgent && (
          <Route
            path="dashboard/agent"
            element={
              <PageFrame>
                <CampaignAgentPage />
              </PageFrame>
            }
          />
        )}

        <Route
          path="billing"
          element={
            <PageFrame>
              <BillingOverviewPage />
            </PageFrame>
          }
        />
        <Route
          path="billing/cafe24-order-result"
          element={
            <PageFrame>
              <Cafe24OrderResultPage />
            </PageFrame>
          }
        />
        <Route
          path="billing/payment-success/:productType"
          element={
            <PageFrame>
              <PaymentResultPage type="success" />
            </PageFrame>
          }
        />
        <Route
          path="billing/payment-fail"
          element={
            <PageFrame>
              <PaymentResultPage type="fail" />
            </PageFrame>
          }
        />

        <Route index element={<Navigate to={PATH.CAMPAIGN_INDEX} />} />
        <Route path="unauthorized" Component={UnauthorizedPage} />
        <Route path="*" Component={NoMatchPage} />
      </Route>

      <Route path="*" element={<div>No Match</div>} />
    </Routes>
  );
}

export default App;
